import { AxiosResponse } from 'axios'

// Don't change this with translations
export const VEHICLE_SIDES = ['inside', 'front', 'left', 'rear', 'right']

export interface DamagesBySide {
  inside: Damage[]
  front: Damage[]
  rear: Damage[]
  left: Damage[]
  right: Damage[]
}

export const INITIAL_DAMAGE_FIELDS: DamagesBySide = {
  inside: [],
  front: [],
  rear: [],
  left: [],
  right: [],
}

export enum QueryKey {
  VehicleData = 'vehicleData',
  Depots = 'depots',
  ImageBlob = 'imageBlob',
}

// Extend the Window interface to include the Android property
declare global {
  interface Window {
    Android?: {
      [x: string]: any
      failVehicleDamageRegistrationApp: () => void
    }
  }
}

export interface Damage {
  id: string
  classifications: string[]
  description: string
  pNumber: string
  photoUrls: string[]
  photoUrlsThumbnails: string[]
  side: string
  status: string
  timestamp: string
  vehicleId: string
  xCoordinate: number
  yCoordinate: number
  voortgang: string
  contactPerson: string
  depotCode: string
  claimUploaded: boolean
  licensePlate?: string
  kind?: string
  locationGeo?: { longitude: number; latitude: number }
  locationByCourierGeo?: { longitude: number; latitude: number }
  counterPartyPresent?: boolean
  vehicleOperational?: boolean
  latestAuditAction?: string
  latestAuditMessage?: string
  involvedCourier?: string
  reporterName?: string
  counterPartyLicensePlate?: string
  damageReport?: string
  damageReportBack?: string
  claimNumber?: string
  kibNumber?: string
  damageTargets?: string[]
  photoUrlsObject?: string[]
  photoUrlsCounterParty?: string[]
  sceneUrls?: string[]
}

export interface History {
  id: number
  timestamp: string
  vehicleId: string
  pNummer: string
  depotCode: string
  photoFront: string
  photoLeft: string
  photoRear: string
  photoRight: string
  photoInside: string
  photoFrontThumb: string
  photoLeftThumb: string
  photoRearThumb: string
  photoRightThumb: string
  photoInsideThumb: string
}

export const VEHICLE_TYPE_SVG_MAP: Record<string, string> = {
  SCV: 'bestelauto',
  LCV: 'bestelwagen',
  MCV: 'bestelbus',
}

export const resolveVehicleTypeSvgName = (vehicleType: string): string =>
  VEHICLE_TYPE_SVG_MAP[vehicleType] ?? vehicleType

export interface VehicleDataResponse extends AxiosResponse {
  data: {
    id: string
    history: History[]
    damages: Damage[]
    vehicleType: string
  }
}
